/**
 * CRUD do catálogo de condições gerais padrão das propostas.
 * Coleção: condicoesCatalogo/{id} = { titulo, texto, ordem, criadoEm }
 * Propostas novas são semeadas com estas condições; editar no orçamento não altera o padrão.
 */

function msOf(ts) {
  if (!ts) return 0;
  if (typeof ts === 'number') return ts;
  if (typeof ts.toDate === 'function') return ts.toDate().getTime();
  return 0;
}

let _cache = [];

/** Leitura síncrona do cache em memória (populado pela subscription). */
export function getCondicoesCatalogoCached() {
  return _cache;
}

export function subscribeCondicoesCatalogo(callback) {
  const db = window._fbDb;
  if (!db || !window._fbCollection || !window._fbOnSnapshot) {
    callback([]);
    return () => {};
  }
  return window._fbOnSnapshot(
    window._fbCollection(db, 'condicoesCatalogo'),
    snap => {
      const list = [];
      snap.forEach(d => list.push({ id: d.id, ...d.data() }));
      list.sort((a, b) => {
        const oa = Number.isFinite(a.ordem) ? a.ordem : msOf(a.criadoEm);
        const ob = Number.isFinite(b.ordem) ? b.ordem : msOf(b.criadoEm);
        if (oa !== ob) return oa - ob;
        return String(a.titulo || '').localeCompare(String(b.titulo || ''));
      });
      _cache = list;
      callback(list);
    },
    () => callback([]),
  );
}

export async function createCondicaoCatalogo({ titulo, texto = '', ordem }) {
  const db = window._fbDb;
  const ref = window._fbCollection(db, 'condicoesCatalogo');
  const docRef = await window._fbAddDoc(ref, {
    titulo: String(titulo || '').trim(),
    texto: String(texto || '').trim(),
    ordem: Number.isFinite(ordem) ? ordem : Date.now(),
    criadoEm: window._fbServerTimestamp(),
  });
  return docRef.id;
}

export async function updateCondicaoCatalogo(id, patch) {
  const db = window._fbDb;
  const ref = window._fbDoc(db, 'condicoesCatalogo', id);
  const body = {};
  if (patch.titulo !== undefined) body.titulo = String(patch.titulo).trim();
  if (patch.texto !== undefined) body.texto = String(patch.texto).trim();
  if (patch.ordem !== undefined) body.ordem = Number(patch.ordem) || 0;
  await window._fbUpdateDoc(ref, body);
}

export async function deleteCondicaoCatalogo(id) {
  const db = window._fbDb;
  await window._fbDeleteDoc(window._fbDoc(db, 'condicoesCatalogo', id));
}
